/* eslint-disable @typescript-eslint/no-explicit-any */
const curatedFacets = (attributeLocale: string): any => {
	switch (attributeLocale) {
		case '_Fr':
			return {
				MusicalStyles_Fr: [
					{ id: 'blues' },
					{ id: 'country' },
					{ id: 'électronique' },
					{ id: 'folk' },
					{ id: 'funk & soul' },
					{ id: 'grands classiques' },
					{ id: 'hip-hop/r&b' },
					{ id: 'indé' },
					{ id: 'jazz' },
					{ id: 'latino' },
					{ id: 'musique du monde' },
					{ id: 'noël' },
					{ id: 'orchestrale, composition et classique' },
					{ id: 'orchestrale hybride' },
					{ id: 'pop' },
					{ id: 'rock' },
				],
				Moods_Fr: [
					{ id: 'attentionnée/réfléchie' },
					{ id: 'célébration' },
					{ id: 'colère/agression/violence' },
					{ id: 'confiance/assurance' },
					{ id: 'décontractée' },
					{ id: 'dramatique' },
					{ id: 'dynamique/énergique' },
					{ id: "entraînant/avec de l'allant" },
					{ id: 'excentrique/étrange/bizarre' },
					{ id: 'frénétique/vive' },
					{ id: 'gênante/laborieuse' },
					{ id: 'héroïque/courageuse' },
					{ id: 'hymne' },
					{ id: 'hypnotique' },
					{ id: 'inspirante' },
					{ id: 'luxueuse/glamour' },
					{ id: 'magique/mystique' },
					{ id: 'mélancolique' },
					{ id: 'négative' },
					{ id: 'neutre' },
					{ id: 'panoramique' },
					{ id: 'positive' },
					{ id: 'positive/optimiste' },
					{ id: 'puissante' },
					{ id: 'romantique' },
					{ id: 'simple/rare/minimale' },
					{ id: 'sinistre' },
					{ id: 'spectrale/inquiétante/effrayante' },
					{ id: 'tension' },
					{ id: 'tension légère' },
				],
				Instrumentations_Fr: [
					{ id: '808/drum machine' },
					{ id: 'applaudissements' },
					{ id: 'batterie' },
					{ id: 'chansons' },
					{ id: 'chœur' },
					{ id: 'clarinette' },
					{ id: 'contrebasse' },
					{ id: 'cordes' },
					{ id: 'cuivres' },
					{ id: 'flute' },
					{ id: 'groupe pop/rock' },
					{ id: 'guitare acoustique' },
					{ id: 'guitare électrique' },
					{ id: 'hammond/leslie/wurlitzer' },
					{ id: 'harpe' },
					{ id: 'hautbois' },
					{ id: 'jazz band' },
					{ id: 'marimba' },
					{ id: 'percussions/drum grooves' },
					{ id: 'percussions orchestrales' },
					{ id: 'piano solo' },
					{ id: 'pizzicato aux cordes' },
					{ id: 'saxophone' },
					{ id: 'synthé/synthétiseur' },
					{ id: 'trombone' },
					{ id: 'tuba' },
					{ id: 'violon' },
					{ id: 'violoncelle' },
					{ id: 'voix féminines' },
					{ id: 'voix masculines' },
				],
				ProductionGenres_Fr: [
					{ id: 'action dramatique' },
					{ id: 'comédie dramatique' },
					{ id: 'commerce et industrie/entreprise' },
					{ id: 'crime/investigation' },
					{ id: 'documentaire' },
					{ id: 'documentaire historique' },
					{ id: 'documentaire sur la faune' },
					{ id: 'drame' },
					{ id: 'drame criminel' },
					{ id: 'drame historique' },
					{ id: 'drame pour ados/la jeunesse' },
					{ id: 'enfants' },
					{ id: 'faune/monde naturel' },
					{ id: 'international et voyage' },
					{ id: 'loisirs/amusement' },
					{ id: 'luxe' },
					{ id: 'mode/défilé/podium' },
					{ id: 'mystère et tension' },
					{ id: 'nocturne' },
					{ id: 'océans/mers/sous-marin' },
					{ id: 'réalité structurée' },
					{ id: 'revue sportive/résumé' },
					{ id: 'sport' },
					{ id: 'sport motorisé' },
					{ id: 'style de vie' },
					{ id: 'styles de film' },
					{ id: 'tension sportive' },
					{ id: 'tv' },
					{ id: 'victoire' },
					{ id: 'voyage/vacances' },
				],
			}

		case '_Es':
			return {
				MusicalStyles_Es: [
					{ id: 'blues' },
					{ id: 'country' },
					{ id: 'electrónica' },
					{ id: 'folk' },
					{ id: 'funk y soul' },
					{ id: 'hiphop/r&b' },
					{ id: 'indie' },
					{ id: 'jazz' },
					{ id: 'latino' },
					{ id: 'música del mundo' },
					{ id: 'navidad' },
					{ id: 'orquestal, cinematográfico y clásico' },
					{ id: 'orquestal híbrido' },
					{ id: 'piezas clásicas famosas' },
					{ id: 'pop' },
					{ id: 'rock' },
				],
				Moods_Es: [
					{ id: 'celebración' },
					{ id: 'dramático' },
					{ id: 'enérgico/animado' },
					{ id: 'espeluznante/inquietante/fantasmagórico' },
					{ id: 'frenético/ágil' },
					{ id: 'heroico/valiente' },
					{ id: 'himno' },
					{ id: 'hipnótico' },
					{ id: 'impulso/movimiento hacia delante/ímpetu' },
					{ id: 'incómodo/pesado' },
					{ id: 'inspirador' },
					{ id: 'ira/agresividad/violencia' },
					{ id: 'lujo/glamur' },
					{ id: 'mágico/místico' },
					{ id: 'negativo' },
					{ id: 'neutral' },
					{ id: 'oscuro' },
					{ id: 'panorámico' },
					{ id: 'peculiar/extraño/raro' },
					{ id: 'positivo' },
					{ id: 'positivo/optimista' },
					{ id: 'potente' },
					{ id: 'reflexivo/pensativo' },
					{ id: 'relajado' },
					{ id: 'romántico' },
					{ id: 'seguridad/pavoneo' },
					{ id: 'sencillo/escaso/mínimo' },
					{ id: 'tensión' },
					{ id: 'tensión suave' },
					{ id: 'triste' },
				],
				Instrumentations_Es: [
					{ id: '808/caja de ritmos' },
					{ id: 'arpa' },
					{ id: 'banda de jazz' },
					{ id: 'banda de pop/rock' },
					{ id: 'batería' },
					{ id: 'canciones' },
					{ id: 'clarinete' },
					{ id: 'contrabajo' },
					{ id: 'coro' },
					{ id: 'flauta' },
					{ id: 'groove de percusión/batería' },
					{ id: 'guitarra acústica' },
					{ id: 'guitarra eléctrica' },
					{ id: 'hammond/leslie/wurlitzer' },
					{ id: 'instrumentos de cuerda' },
					{ id: 'instrumentos de viento-metal' },
					{ id: 'marimba' },
					{ id: 'oboe' },
					{ id: 'palmadas' },
					{ id: 'percusión orquestal' },
					{ id: 'piano solista' },
					{ id: 'pizzicato de cuerda' },
					{ id: 'saxofón' },
					{ id: 'sintetizador' },
					{ id: 'trombón' },
					{ id: 'tuba' },
					{ id: 'violín' },
					{ id: 'violonchelo' },
					{ id: 'voz femenina' },
					{ id: 'voz masculina' },
				],
				ProductionGenres_Es: [
					{ id: 'comedia dramática' },
					{ id: 'crimen/investigación' },
					{ id: 'deporte' },
					{ id: 'deporte de motor' },
					{ id: 'documental' },
					{ id: 'documental de vida salvaje' },
					{ id: 'documental histórico' },
					{ id: 'drama' },
					{ id: 'drama adolescente/juvenil' },
					{ id: 'drama de acción' },
					{ id: 'drama histórico' },
					{ id: 'drama policiaco' },
					{ id: 'estilo de vida' },
					{ id: 'estilos de cine/películas' },
					{ id: 'fauna/mundo natural' },
					{ id: 'internacional y viaje' },
					{ id: 'late night' },
					{ id: 'lujo' },
					{ id: 'misterio y tensión' },
					{ id: 'negocio e industria/empresas' },
					{ id: 'niños' },
					{ id: 'océanos/mares/submarino' },
					{ id: 'ocio/entretenimiento' },
					{ id: 'pasarela/moda' },
					{ id: 'realidad estructurada' },
					{ id: 'resumen/repaso deportivo' },
					{ id: 'tensión deportiva' },
					{ id: 'tv' },
					{ id: 'viajes/vacaciones' },
					{ id: 'victoria/vencer' },
				],
			}
		case '_De':
			return {
				MusicalStyles_De: [
					{ id: 'berühmte klassische werke' },
					{ id: 'blues' },
					{ id: 'country' },
					{ id: 'elektronisch' },
					{ id: 'folk' },
					{ id: 'funk & soul' },
					{ id: 'hip-hop/r&b' },
					{ id: 'hybrid orchester' },
					{ id: 'indie' },
					{ id: 'jazz' },
					{ id: 'lateinamerikanisch' },
					{ id: 'orchester, partitur und klassik' },
					{ id: 'pop' },
					{ id: 'weihnachten' },
					{ id: 'weltmusik' },
					{ id: 'rock' },
				],
				Moods_De: [
					{ id: 'dramatisch' },
					{ id: 'düster' },
					{ id: 'einfach/spärlich/minimal' },
					{ id: 'energetisch/beschwingt' },
					{ id: 'entspannt' },
					{ id: 'feierlich' },
					{ id: 'geisterhaft/unheimlich/gespenstisch' },
					{ id: 'hektisch/gestresst' },
					{ id: 'heroisch/mutig' },
					{ id: 'hymnisch' },
					{ id: 'hypnotisch' },
					{ id: 'inspirierend' },
					{ id: 'kraftvoll' },
					{ id: 'leichte spannung' },
					{ id: 'luxus/glamour' },
					{ id: 'magisch/mystisch' },
					{ id: 'nachdenklich/reflektierend' },
					{ id: 'negativ' },
					{ id: 'neutral' },
					{ id: 'panoramisch' },
					{ id: 'positiv' },
					{ id: 'positiv/optimistisch' },
					{ id: 'romantisch' },
					{ id: 'selbstbewusst/schwungvoll' },
					{ id: 'skurril/schräg/seltsam' },
					{ id: 'spannung' },
					{ id: 'traurig' },
					{ id: 'treibend/vorwärtsbewegung/momentum' },
					{ id: 'unangenehm/schwermütig' },
					{ id: 'wut/aggression/gewalt' },
				],
				Instrumentations_De: [
					{ id: '808/drum machine' },
					{ id: 'akustische gitarre' },
					{ id: 'blechbläser' },
					{ id: 'cello' },
					{ id: 'chor' },
					{ id: 'e-gitarre' },
					{ id: 'flöte' },
					{ id: 'hammond/leslie/wurlitzer' },
					{ id: 'handklatschen' },
					{ id: 'harfe' },
					{ id: 'jazz-band' },
					{ id: 'klarinette' },
					{ id: 'kontrabass' },
					{ id: 'männlicher gesang' },
					{ id: 'marimba' },
					{ id: 'oboe' },
					{ id: 'orchestrale percussion' },
					{ id: 'percussion/drum grooves' },
					{ id: 'pizzicato-streicher' },
					{ id: 'pop-/rock-band' },
					{ id: 'posaune' },
					{ id: 'saxofon' },
					{ id: 'schlagzeug' },
					{ id: 'solo-klavier' },
					{ id: 'songs' },
					{ id: 'streicher' },
					{ id: 'synths/synthesizer' },
					{ id: 'tuba' },
					{ id: 'violine' },
					{ id: 'weiblicher gesang' },
				],
				ProductionGenres_De: [
					{ id: 'actiondrama' },
					{ id: 'business und unternehmen' },
					{ id: 'dokumentarfilm' },
					{ id: 'drama' },
					{ id: 'dramedy' },
					{ id: 'freizeit/erholung' },
					{ id: 'historischer dokumentarfilm' },
					{ id: 'historisches drama' },
					{ id: 'international und reisen' },
					{ id: 'kinder' },
					{ id: 'kino-/filmstile' },
					{ id: 'krimidrama' },
					{ id: 'late-night-show' },
					{ id: 'lifestyle' },
					{ id: 'luxus' },
					{ id: 'mode/catwalk/laufsteg' },
					{ id: 'motorsport' },
					{ id: 'mystery und spannung' },
					{ id: 'ozeane/meere/unterwasser' },
					{ id: 'reise/urlaub' },
					{ id: 'siege/gewinne' },
					{ id: 'sport' },
					{ id: 'sportrundschau' },
					{ id: 'sport und spannung' },
					{ id: 'structured reality' },
					{ id: 'teen-/jugend-drama' },
					{ id: 'tv' },
					{ id: 'verbrechen/ermittlungen' },
					{ id: 'wildnis/naturwelt' },
					{ id: 'wildtier-dokumentation' },
				],
			}
		case '_It':
			return {
				MusicalStyles_It: [
					{ id: 'blues' },
					{ id: 'country' },
					{ id: 'elettronica' },
					{ id: 'folk' },
					{ id: 'funk e soul' },
					{ id: 'hip hop/r&b' },
					{ id: 'indie' },
					{ id: 'jazz' },
					{ id: 'latina' },
					{ id: 'natale' },
					{ id: 'opere classiche celebri' },
					{ id: 'orchestrale, colonna sonora, classica' },
					{ id: 'orchestrale ibrida' },
					{ id: 'pop' },
					{ id: 'world music' },
					{ id: 'rock' },
				],
				Moods_It: [
					{ id: 'bizzarro/inusuale/strano' },
					{ id: 'celebrazione' },
					{ id: 'drammatico' },
					{ id: 'energico/vivace' },
					{ id: 'eroico/coraggioso' },
					{ id: 'fiducioso/spavaldo' },
					{ id: 'goffo/lento' },
					{ id: 'ipnotico' },
					{ id: 'irrequieto/indaffarato' },
					{ id: 'lusso/glamour' },
					{ id: 'magico/mistico' },
					{ id: 'motivante' },
					{ id: 'negativo' },
					{ id: 'neutrale' },
					{ id: 'oscuro' },
					{ id: 'panoramico' },
					{ id: 'pensoso/riflessivo' },
					{ id: 'poderoso' },
					{ id: 'positivo' },
					{ id: 'positivo/ottimistico' },
					{ id: 'rabbia/aggressione/violenza' },
					{ id: 'rilassato' },
					{ id: 'romantico' },
					{ id: 'semplice/scarno/minimalistico' },
					{ id: 'spettrale/misterioso/inquietante' },
					{ id: 'stimolante' },
					{ id: 'tensione' },
					{ id: 'tensione leggera' },
					{ id: 'trascinante/scattante/ritmico' },
					{ id: 'triste' },
				],
				Instrumentations_It: [
					{ id: '808/drum machine' },
					{ id: 'applausi' },
					{ id: 'archi' },
					{ id: 'archi pizzicati' },
					{ id: 'arpa' },
					{ id: 'batteria' },
					{ id: 'canzoni' },
					{ id: 'chitarra acustica' },
					{ id: 'chitarra elettrica' },
					{ id: 'clarinetto' },
					{ id: 'contrabbasso' },
					{ id: 'coro' },
					{ id: 'flauto' },
					{ id: 'hammond/leslie/wurlitzer' },
					{ id: 'jazz band' },
					{ id: 'marimba' },
					{ id: 'oboe' },
					{ id: 'ottoni' },
					{ id: 'percussioni/groove di batteria' },
					{ id: 'percussioni orchestrali' },
					{ id: 'piano solista' },
					{ id: 'pop/rock band' },
					{ id: 'sassofono' },
					{ id: 'synth/sintetizzatore' },
					{ id: 'trombone' },
					{ id: 'tuba' },
					{ id: 'violino' },
					{ id: 'violoncello' },
					{ id: 'voce femminile' },
					{ id: 'voce maschile' },
				],
				ProductionGenres_It: [
					{ id: 'bambini' },
					{ id: 'corporate e industriale' },
					{ id: 'documentario' },
					{ id: 'documentario fauna selvatica' },
					{ id: 'documentario storico' },
					{ id: 'dramedy' },
					{ id: 'dramma adolescenziale' },
					{ id: "dramma d'azione" },
					{ id: 'dramma/emozioni intense' },
					{ id: 'dramma storico' },
					{ id: 'fauna selvatica/mondo naturale' },
					{ id: 'film/cinema/generi cinematografici' },
					{ id: 'giallo' },
					{ id: 'giallo/indagini' },
					{ id: 'internazionale e viaggi' },
					{ id: 'lifestyle' },
					{ id: 'lusso' },
					{ id: 'mistero e tensione' },
					{ id: 'moda/passerella' },
					{ id: 'notizie/sommari sullo sport' },
					{ id: 'notturno' },
					{ id: 'oceani/mari/fondali marini' },
					{ id: 'reality strutturato' },
					{ id: 'sport' },
					{ id: 'sport motoristici' },
					{ id: 'tempo libero/svago' },
					{ id: 'tensione nello sport' },
					{ id: 'tv' },
					{ id: 'viaggi/vacanze' },
					{ id: 'vittoria/trionfo' },
				],
			}
		case '_Jp':
			return {
				MusicalStyles_Jp: [
					{ id: 'ジャズ' },
					{ id: 'ポップ' },
					{ id: 'ラテン' },
					{ id: 'フォーク' },
					{ id: 'ブルース' },
					{ id: 'ファンク&ソウル' },
					{ id: 'インディー' },
					{ id: 'クリスマス' },
					{ id: 'エレクトロニック' },
					{ id: 'オーケストラ、スコア & クラシック' },
					{ id: 'ハイブリッドオーケストラ' },
					{ id: 'ヒップホップ / r&b' },
					{ id: '世界の音楽 / ワールドミュージック' },
					{ id: 'クラシックの名曲' },
					{ id: '国' },
					{ id: 'ロック' },
				],
				Moods_Jp: [
					{ id: 'シンプル / まばらな /ミニマル' },
					{ id: 'ネガティブ' },
					{ id: 'ポジティブ' },
					{ id: 'ドラマチック' },
					{ id: 'ニュートラル' },
					{ id: 'パノラミック' },
					{ id: 'レイドバック' },
					{ id: 'ロマンチック' },
					{ id: 'ヒプノティック' },
					{ id: '前向き / 楽観的' },
					{ id: '力強い' },
					{ id: '力強い / アップビート' },
					{ id: '加速 / 前進 / 勢い' },
					{ id: '心に響く' },
					{ id: '怒り/ 攻撃 / 暴力' },
					{ id: '悲しみ' },
					{ id: '暗い' },
					{ id: '気味の悪い / 不気味 / 幽霊の出そうな' },
					{ id: '物思いにふける / 内省的' },
					{ id: '狂乱 / 騒がしい' },
					{ id: 'ぎこちない / 生真面目' },
					{ id: '祝典' },
					{ id: 'マジカル / 神秘的' },
					{ id: '緊張' },
					{ id: '自信 / 威張った' },
					{ id: '英雄の / 勇ましい' },
					{ id: '豪華 / 魅力的' },
					{ id: '軽い緊張' },
					{ id: 'アンセム風' },
					{ id: '風変わり / 奇妙 / 変な' },
				],
				Instrumentations_Jp: [
					{ id: 'チェロ' },
					{ id: 'ハープ' },
					{ id: 'ポップ / ロックバンド' },
					{ id: 'シンセ / シンセサイザー' },
					{ id: 'オーボエ' },
					{ id: 'サックス' },
					{ id: 'チューバ' },
					{ id: 'フルート' },
					{ id: 'マリンバ' },
					{ id: 'ハモンド / レスリー / ウーリッツァー' },
					{ id: 'ソロピアノ' },
					{ id: 'バイオリン' },
					{ id: 'クラリネット' },
					{ id: 'ジャズバンド' },
					{ id: 'ストリングス' },
					{ id: 'トロンボーン' },
					{ id: 'ドラムキット' },
					{ id: 'ダブルベース / コントラバス' },
					{ id: 'ハンドクラップ' },
					{ id: 'エレクトリックギター' },
					{ id: 'アコースティックギター' },
					{ id: 'ピチカートストリングス' },
					{ id: '808 / ドラムマシン' },
					{ id: '女性ボーカル' },
					{ id: 'オーケストラ打楽器' },
					{ id: '打楽器 / ドラムグルーヴ' },
					{ id: '歌' },
					{ id: '男性ボーカル' },
					{ id: '聖歌隊' },
					{ id: '金管楽器' },
				],
				ProductionGenres_Jp: [
					{ id: 'テレビ' },
					{ id: 'ドラマ' },
					{ id: 'スポーツ' },
					{ id: 'レジャー/ レクリエーション' },
					{ id: 'ファッション / キャットウォーク / ランウェイ' },
					{ id: 'ライフスタイル' },
					{ id: 'アクションドラマ' },
					{ id: 'コメディードラマ' },
					{ id: 'ドキュメンタリー' },
					{ id: 'モータースポーツ' },
					{ id: '優勝 / 勝利' },
					{ id: '国際 & トラベル' },
					{ id: '子ども' },
					{ id: '旅行 / ホリデー' },
					{ id: 'フィルム / シネマ / 映画スタイル' },
					{ id: '歴史ドラマ' },
					{ id: '歴史ドキュメンタリー' },
					{ id: '海洋 / 海 / 水中' },
					{ id: '深夜' },
					{ id: '犯罪ドラマ' },
					{ id: '犯罪 / 捜査' },
					{ id: 'ビジネス & 産業 / 企業' },
					{ id: '筋書のあるリアリティ番組' },
					{ id: 'スポーツの緊張感' },
					{ id: 'ミステリー & 緊迫' },
					{ id: 'スポーツの総まとめ / 要約' },
					{ id: 'ティーン / 若者向けドラマ' },
					{ id: '豪華 / 贅沢' },
					{ id: '野生動物ドキュメンタリー' },
					{ id: '野生動物 / 自然界' },
				],
			}
		case '_Pt':
			return {
				MusicalStyles_Pt: [
					{ id: 'blues' },
					{ id: 'clássica, bandas sonoras e orquestral' },
					{ id: 'country' },
					{ id: 'eletrónica' },
					{ id: 'folk' },
					{ id: 'funk & soul' },
					{ id: 'hip-hop/r&b' },
					{ id: 'indie' },
					{ id: 'jazz' },
					{ id: 'latina' },
					{ id: 'música global' },
					{ id: 'natalício' },
					{ id: 'obras clássicas famosas' },
					{ id: 'orquestral híbrido' },
					{ id: 'pop' },
					{ id: 'rock' },
				],
				Moods_Pt: [
					{ id: 'celebração' },
					{ id: 'confiante/arrogante' },
					{ id: 'desastrado/penoso' },
					{ id: 'descontraído' },
					{ id: 'dramático' },
					{ id: 'energético/animado' },
					{ id: 'enérgico/acelerado/dinâmico' },
					{ id: 'fantasmagórico/sombrio/assustador' },
					{ id: 'frenético/ocupado' },
					{ id: 'heroico/corajoso' },
					{ id: 'hinos' },
					{ id: 'hipnotizante' },
					{ id: 'inspiracional' },
					{ id: 'luxo/glamour' },
					{ id: 'mágico/místico' },
					{ id: 'negativo' },
					{ id: 'negro' },
					{ id: 'neutro' },
					{ id: 'original/estranho' },
					{ id: 'panorâmico' },
					{ id: 'poderoso' },
					{ id: 'ponderado/meditativo' },
					{ id: 'positivo' },
					{ id: 'positivo/otimista' },
					{ id: 'raiva/agressão/violência' },
					{ id: 'romântico' },
					{ id: 'simples/minimalista' },
					{ id: 'tensão' },
					{ id: 'tensão leve' },
					{ id: 'triste' },
				],
				Instrumentations_Pt: [
					{ id: '808/caixa de ritmos' },
					{ id: 'banda jazz' },
					{ id: 'banda pop/rock' },
					{ id: 'bateria' },
					{ id: 'canções' },
					{ id: 'clarinete' },
					{ id: 'contrabaixo' },
					{ id: 'cordas' },
					{ id: 'cordas pizzicato' },
					{ id: 'coro' },
					{ id: 'flauta' },
					{ id: 'grooves de percussão/bateria' },
					{ id: 'guitarra acústica' },
					{ id: 'guitarra elétrica' },
					{ id: 'hammond/leslie/wurlitzer' },
					{ id: 'harpa' },
					{ id: 'marimba' },
					{ id: 'metais' },
					{ id: 'oboé' },
					{ id: 'palmas' },
					{ id: 'percussão de orquestra' },
					{ id: 'piano a solo' },
					{ id: 'saxofone' },
					{ id: 'sintetizador' },
					{ id: 'trombone' },
					{ id: 'tuba' },
					{ id: 'violino' },
					{ id: 'violoncelo' },
					{ id: 'voz feminina' },
					{ id: 'voz masculina' },
				],
				ProductionGenres_Pt: [
					{ id: 'comédia dramática' },
					{ id: 'crime/investigação' },
					{ id: 'desporto' },
					{ id: 'desportos motorizados' },
					{ id: 'documentário' },
					{ id: 'documentário histórico' },
					{ id: 'documentário vida selvagem' },
					{ id: 'drama' },
					{ id: 'drama adolescente/jovem' },
					{ id: 'drama criminal' },
					{ id: 'drama de ação' },
					{ id: 'drama histórico' },
					{ id: 'filmes/cinema/estilos cinematográficos' },
					{ id: 'industrial e empresarial' },
					{ id: 'infantil' },
					{ id: 'internacional e viagens' },
					{ id: 'lazer' },
					{ id: 'lifestyle' },
					{ id: 'luxo' },
					{ id: 'madrugada' },
					{ id: 'mistério e tensão' },
					{ id: 'moda/passerelle' },
					{ id: 'oceanos/mares/subaquático' },
					{ id: 'realidade estruturada' },
					{ id: 'resumos desportivos' },
					{ id: 'tensão desportiva' },
					{ id: 'tv' },
					{ id: 'viagens/férias' },
					{ id: 'vida selvagem/natureza' },
					{ id: 'vitória' },
				],
			}
		case '_Cn':
			return {
				MusicalStyles_Cn: [
					{ id: '乡村' },
					{ id: '全球音乐' },
					{ id: '嘻哈/节奏布鲁斯' },
					{ id: '圣诞' },
					{ id: '拉丁' },
					{ id: '放克与灵魂乐' },
					{ id: '民谣' },
					{ id: '流行乐' },
					{ id: '混合管弦乐' },
					{ id: '爵士' },
					{ id: '独立' },
					{ id: '电子乐' },
					{ id: '管弦乐/配乐/古典乐' },
					{ id: '著名古典作品' },
					{ id: '蓝调' },
					{ id: '摇滚' },
				],
				Moods_Cn: [
					{ id: '中性' },
					{ id: '催眠' },
					{ id: '古怪/奇怪' },
					{ id: '启发心灵' },
					{ id: '壮观' },
					{ id: '奇妙/神秘' },
					{ id: '奢华/迷人' },
					{ id: '强大' },
					{ id: '悲伤' },
					{ id: '愤怒/激进/暴力' },
					{ id: '慵懒' },
					{ id: '振奋/向前/动力' },
					{ id: '欢乐庆典' },
					{ id: '活力十足/昂扬' },
					{ id: '浪漫' },
					{ id: '消极' },
					{ id: '深思/反思' },
					{ id: '狂乱/繁忙' },
					{ id: '积极' },
					{ id: '积极/乐观' },
					{ id: '笨重/沉重缓慢' },
					{ id: '简单/零散/极简' },
					{ id: '紧张' },
					{ id: '自信/拽酷' },
					{ id: '英勇/无畏' },
					{ id: '诡异/怪诞/幽灵般' },
					{ id: '跌宕起伏' },
					{ id: '轻快' },
					{ id: '颂歌' },
					{ id: '黑暗' },
				],
				Instrumentations_Cn: [
					{ id: '808/电子鼓' },
					{ id: '交响打击乐器' },
					{ id: '低音提琴' },
					{ id: '单簧管' },
					{ id: '原声吉他' },
					{ id: '双簧管' },
					{ id: '合唱' },
					{ id: '合成/合成器' },
					{ id: '哈蒙德/莱斯利/沃利策风琴' },
					{ id: '大号' },
					{ id: '大提琴' },
					{ id: '女声' },
					{ id: '小提琴' },
					{ id: '弦乐' },
					{ id: '弹拨弦乐' },
					{ id: '打击乐器/鼓点律动' },
					{ id: '拍掌' },
					{ id: '歌曲' },
					{ id: '流行/摇滚乐队' },
					{ id: '爵士乐队' },
					{ id: '独奏钢琴' },
					{ id: '电吉他' },
					{ id: '男声' },
					{ id: '竖琴' },
					{ id: '萨克斯管' },
					{ id: '铜管乐器' },
					{ id: '长号' },
					{ id: '长笛' },
					{ id: '马林巴琴' },
					{ id: '鼓组' },
				],
				ProductionGenres_Cn: [
					{ id: '休闲/娱乐' },
					{ id: '体育综述/回顾' },
					{ id: '体育运动' },
					{ id: '儿童' },
					{ id: '剧情' },
					{ id: '动作剧' },
					{ id: '动物/自然' },
					{ id: '历史剧' },
					{ id: '历史纪录片' },
					{ id: '商务/工业/企业' },
					{ id: '国际和旅行' },
					{ id: '奢华' },
					{ id: '影片/电影风格' },
					{ id: '情节喜剧' },
					{ id: '旅行/度假' },
					{ id: '时尚/走秀' },
					{ id: '海洋/水下' },
					{ id: '深夜' },
					{ id: '犯罪剧' },
					{ id: '犯罪/调查' },
					{ id: '生活方式' },
					{ id: '电视' },
					{ id: '真人剧' },
					{ id: '神秘/紧张' },
					{ id: '纪录片' },
					{ id: '获胜/ 胜利' },
					{ id: '赛车运动' },
					{ id: '运动紧张感' },
					{ id: '野生动物纪录片' },
					{ id: '青少年/青春剧' },
				],
			}

		default:
			return {
				MusicalStyles: [
					{ id: 'blues' },
					{ id: 'christmas' },
					{ id: 'country' },
					{ id: 'electronic' },
					{ id: 'famous classical works' },
					{ id: 'folk' },
					{ id: 'funk & soul' },
					{ id: 'global music' },
					{ id: 'hip hop/r&b' },
					{ id: 'hybrid orchestral' },
					{ id: 'indie' },
					{ id: 'jazz' },
					{ id: 'latin' },
					{ id: 'orchestral, score & classical' },
					{ id: 'pop' },
					{ id: 'rock' },
				],
				Moods: [
					{ id: 'anger/aggression/violence' },
					{ id: 'anthemic' },
					{ id: 'awkward/plodding' },
					{ id: 'celebration' },
					{ id: 'confident/swagger' },
					{ id: 'dark' },
					{ id: 'dramatic' },
					{ id: 'driving/forward motion/momentum' },
					{ id: 'energetic/upbeat' },
					{ id: 'frantic/busy' },
					{ id: 'ghostly/eerie/spooky' },
					{ id: 'heroic/courageous' },
					{ id: 'hypnotic' },
					{ id: 'inspirational' },
					{ id: 'laid back' },
					{ id: 'light tension' },
					{ id: 'luxury/glamour' },
					{ id: 'magic/mystical' },
					{ id: 'negative' },
					{ id: 'neutral' },
					{ id: 'panoramic' },
					{ id: 'positive' },
					{ id: 'positive/optimistic' },
					{ id: 'powerful' },
					{ id: 'quirky/strange/weird' },
					{ id: 'romantic' },
					{ id: 'sad' },
					{ id: 'simple/sparse/minimal' },
					{ id: 'tension' },
					{ id: 'thoughtful/reflective' },
				],
				Instrumentations: [
					{ id: '808/drum machine' },
					{ id: 'acoustic guitar' },
					{ id: 'brass' },
					{ id: 'cello' },
					{ id: 'choir' },
					{ id: 'clarinet' },
					{ id: 'double bass' },
					{ id: 'drum kit' },
					{ id: 'electric guitar' },
					{ id: 'female vocal' },
					{ id: 'flute' },
					{ id: 'hammond/leslie/wurlitzer' },
					{ id: 'hand claps' },
					{ id: 'harp' },
					{ id: 'jazz band' },
					{ id: 'male vocal' },
					{ id: 'marimba' },
					{ id: 'oboe' },
					{ id: 'orchestral percussion' },
					{ id: 'percussion/drum grooves' },
					{ id: 'pizzicato strings' },
					{ id: 'pop/rock band' },
					{ id: 'saxophone' },
					{ id: 'solo piano' },
					{ id: 'songs' },
					{ id: 'strings' },
					{ id: 'synths/synthesizer' },
					{ id: 'trombone' },
					{ id: 'tuba' },
					{ id: 'violin' },
				],
				ProductionGenres: [
					{ id: 'action drama' },
					{ id: 'business & industrial/corporate' },
					{ id: 'children' },
					{ id: 'crime drama' },
					{ id: 'crime/investigation' },
					{ id: 'documentary' },
					{ id: 'drama' },
					{ id: 'dramedy' },
					{ id: 'fashion/catwalk/runway' },
					{ id: 'film/cinema/movie styles' },
					{ id: 'historical documentary' },
					{ id: 'historical drama' },
					{ id: 'international & travel' },
					{ id: 'late night' },
					{ id: 'leisure/recreation' },
					{ id: 'lifestyle' },
					{ id: 'luxury' },
					{ id: 'motorsport' },
					{ id: 'mystery & tension' },
					{ id: 'oceans/seas/underwater' },
					{ id: 'sport' },
					{ id: 'sports roundup/recap' },
					{ id: 'sports tension' },
					{ id: 'structured reality' },
					{ id: 'teen/youth drama' },
					{ id: 'travel/holiday' },
					{ id: 'tv' },
					{ id: 'victory/winning' },
					{ id: 'wildlife documentary' },
					{ id: 'wildlife/natural world' },
				],
			}
	}
}

export default curatedFacets
